import React from 'react';

function searchResult(props) {
    const { post, currentSearchTerm } = props;
    let excerpt = post.excerpt;
    function matchCase(text, pattern) {
        let result = '';

        for (let i = 0; i < text.length; i++) {
            const c = text.charAt(i);
            const p = pattern.charCodeAt(i);

            if (p >= 65 && p < 65 + 26) {
                result += c.toUpperCase();
            } else {
                result += c.toLowerCase();
            }
        }

        return `<span class="keyword">${result}</span>`;
    }

    const regex = new RegExp(currentSearchTerm, 'gi');

    function theExcerpt(content) {
        content = content.replace('[&hellip;]', ``);
        content = content.split(' ');
        if (content.length > 25) {
            content = content.splice(0, 25).join(' ');
            content += '...';
        } else {
            content = content.join(' ');
        }

        if (currentSearchTerm !== '') {
            content = content.replace(regex, (match) => {
                return matchCase(currentSearchTerm, match);
            });
        }

        return content;
    }

    if (excerpt) {
        excerpt = (
            <div
                className="eight29-post-excerpt"
                dangerouslySetInnerHTML={{
                    __html: theExcerpt(excerpt),
                }}
            ></div>
        );
    }

    return (
        <article className="eight29-post eight29-search-result">
            <a className="eight29-post-link" href={post.link}>

                <h4
                    className="eight29-post-title"
                    dangerouslySetInnerHTML={{ __html: post.title }}
                />
                {excerpt}
            </a>
        </article>
    );
}

export default searchResult;
